export default "__VITE_ASSET__BcWe8Yyh__"